const IMPORT_TYPE_OPTIONS = {
  STATIC: 'STATIC',
  ITEM_LOOKUP: 'ITEM_LOOKUP',
};

export default IMPORT_TYPE_OPTIONS;
